import CalendarConfiguration from "@/components/logistics/configuration/calendar-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/calendars",
)({
  component: CalendarsPage,
});

function CalendarsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "consolidation_calendars", actions: ["read", "update"] },
      ]}
    >
      <CalendarConfiguration module="consolidation_calendars" />
    </RouteGuardPermissions>
  );
}
